import cropr, { BackboneModel } from "../utils/cropr";
import { useEffect, useState } from "react";

export const useSFAMBackbone = <T extends BackboneModel = BackboneModel>(
  collectionName: "advices" | "cropFieldAdvices" | "cropFieldGroupAdvices" | "cropFields"
): [any[], Backbone.Collection<T>] => {
  // @ts-ignore
  const collection = cropr.sfam[collectionName];
  const [attributes, setAttributes] = useState<any>(collection.toJSON());

  useEffect(() => {
    const handleChange = () => {
      setAttributes(collection.toJSON());
    };

    collection.on("all", handleChange);
    return () => {
      collection.off("all", handleChange);
    };
  }, [collection]);

  // @ts-ignore
  return [attributes, collection];
};
